// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2BgXd","tab":"ProcedureTabs_tab__eljpK"};